import * as styles from "./KnobTrack.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useKnobContext } from "./Knob.context";
import type { KnobTrackProps } from "./Knob.types";

export function KnobTrack({
  className,
  children,
}: KnobTrackProps): JSX.Element {
  const { diameter, radius, strokeWidth } = useKnobContext();
  const center = diameter / 2;

  return (
    <svg
      data-slot="knob-track"
      className={clsx(styles.track, className)}
      width="100%"
      height="100%"
      viewBox={`0 0 ${diameter} ${diameter}`}
    >
      <circle
        className={styles.background}
        cx={center}
        cy={center}
        r={radius}
        strokeWidth={strokeWidth}
        fill="none"
      />
      {children}
    </svg>
  );
}
